import Vue from 'vue';

import Vuex from 'vuex';

import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(Vuex, VueAxios, axios);

// ICONS
import {
  addItemIcon,
  calendarTimeIcon,
  commissionIcon,
  invoiceIcon,
  partnerIcon,
  warningIcon,
} from '@deanone/dean-components';

// PRODUCTS
export const requestProducts = (context: any, data: any) => {
  const url = '/-/trade/api/settings.product.list';

  return axios.post(url, {
    meta: {
      startIndex: (data?.pageNumber - 1) * data?.itemsPerPage,
      numberOfItems: data?.itemsPerPage,
    },
    status: data?.status,
    sort: data?.sort,
    filter: data?.query,
  });
};

export const requestProduct = (context: any, data: any) => {
  const url = '/-/trade/api/settings.product.info';

  return axios.post(url, data);
};

export const processProduct = (context: any, productData: any) => {
  const url = '/-/trade/api/settings.product.save';

  return axios.post(url, productData);
};

// Bundle products (products with isPbxBundle=true)
export const requestBundleProducts = (context: any) => {
  const url = '/-/trade/api/settings.product.list';

  return axios.post(url, {
    isPbxBundle: true,
    meta: {
      startIndex: 0,
      numberOfItems: 1000,
    },
  });
};

// Provisioning services
export const requestProvisioningServices = (context: any) => {
  const url = '/-/trade/api/admin.provisioning.service.list';

  return axios.post(url);
};

export const requestProvisioningService = (context: any, data: any) => {
  const url = '/-/trade/api/admin.provisioning.service.info';

  return axios.post(url, { identifier: data.id });
};

export const processProvisioningService = (context: any, data: any) => {
  const updateUrl = '/-/trade/api/admin.provisioning.service.update';
  const createUrl = '/-/trade/api/admin.provisioning.service.create';

  return axios.post(data.identifier ? updateUrl : createUrl, data);
};

// Odido products
export const requestOdidoProducts = (context: any) => {
  const url = '/-/trade/api/admin.odido.product.list';

  return axios.post(url);
};

export const requestOdidoProduct = (context: any, data: any) => {
  const url = '/-/trade/api/admin.odido.product.info';

  return axios.post(url, { identifier: data.id });
};

export const processOdidoProducts = (context: any, data: any) => {
  const updateUrl = '/-/trade/api/admin.odido.product.update';
  const createUrl = '/-/trade/api/admin.odido.product.create';

  return axios.post(data.identifier ? updateUrl : createUrl, data);
};

// KPN products
export const requestKpnProducts = (context: any) => {
  const url = '/-/trade/api/admin.kpn.product.list';

  return axios.post(url);
};

export const requestKpnProductInfo = (context: any, data: any) => {
  const url = '/-/trade/api/admin.kpn.product.info';

  return axios.post(url, { identifier: data.identifier });
};

export const processKpnProduct = (context: any, data: any) => {
  const updateUrl = '/-/trade/api/admin.kpn.product.update';
  const createUrl = '/-/trade/api/admin.kpn.product.create';

  return axios.post(data.identifier ? updateUrl : createUrl, data);
};

export const requestVatCodes = (context: any, data: any) => {
  const url = '/-/trade/api/settings.vatCode.list';

  return axios.post(url, {
    meta: {
      startIndex: (data?.pageNumber - 1) * data?.itemsPerPage,
      numberOfItems: data?.itemsPerPage,
    },
    sort: data?.sort,
  });
};

export const requestProductTerm = (context: any, data: any) => {
  const url = '/-/trade/api/settings.productTerm.info';

  return axios.post(url, data);
};

export const processProductTerm = (context: any, data: any) => {
  const url = '/-/trade/api/settings.productTerm.save';

  return axios.post(url, data);
};

// PRICEPLANS
export const requestPricePlans = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.list';

  return axios.post(url, {
    meta: {
      startIndex: (data?.pageNumber - 1) * data?.itemsPerPage,
      numberOfItems: data?.itemsPerPage,
    },
    sort: data?.sort,
  });
};

export const requestPricePlan = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.info';

  return axios.post(url, {
    id: data.id,
  });
};

export const processPricePlanCreate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.save';

  return axios.post(url, {
    name: data.name,
    partnerAgreementTypes: data.partnerAgreementTypes,
  });
};

export const processPricePlanUpdate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.save';

  return axios.post(url, {
    id: data.id,
    name: data.name,
    partnerAgreementTypes: data.partnerAgreementTypes,
  });
};

// PRICEPLAN PERIODS
export const requestPricePlanPeriods = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.period.list';

  return axios.post(url, {
    pricePlanId: data.pricePlanId,
  });
};

export const processPricePlanPeriodCreate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.period.create';

  return axios.post(url, {
    pricePlanId: data.pricePlanId,
    newStartDate: data.newStartDate,
    newEndDate: data.newEndDate,
  });
};

export const processPricePlanPeriodUpdate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.period.update';

  return axios.post(url, {
    pricePlanId: data.pricePlanId,
    startDate: data.startDate,
    endDate: data.endDate,
    newStartDate: data.newStartDate,
    newEndDate: data.newEndDate,
  });
};

// PRICEPLANS ENTRIES
export const requestPricePlanEntries = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlanEntry.list';

  return axios.post(url, {
    pricePlanId: data.pricePlanId,
    meta: {
      startIndex: (data.pageNumber - 1) * data.itemsPerPage,
      numberOfItems: data.itemsPerPage,
    },
    sort: data.sort,
    startDate: data.startDate,
    endDate: data.endDate,
  });
};

export const requestPricePlanEntry = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlanEntry.info';

  return axios.post(url, {
    id: data.id,
    pricePlanId: data.pricePlanId,
  });
};

export const requestPricePlanEntryAvailableProducts = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlanEntry.availableProducts';

  return axios.post(url, {
    pricePlanId: data.pricePlanId,
    startDate: data.startDate,
    endDate: data.endDate,
    productId: data.productId,
  });
};

export const savePricePlanEntry = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlanEntry.save';

  return axios.post(url, {
    id: data.id,
    pricePlanId: data.pricePlanId,
    startDate: data.startDate,
    endDate: data.endDate,
    productId: data.productId,
    connectPrice: data.connectPrice,
    recurringPrice: data.recurringPrice,
    disconnectPrice: data.disconnectPrice,
  });
};

export const deletePricePlanEntry = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlanEntry.delete';

  return axios.post(url, {
    id: data.id,
    pricePlanId: data.pricePlanId,
  });
};

export const processPricePlanDuplicate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.pricePlan.duplicate';

  return axios.post(url, {
    name: data.name,
    id: data.id,
  });
};

// PARTNER AGREEMENT TYPES
export const requestPartnerAgreementTypes = (context: any, data: any) => {
  const url = '/-/trade/api/settings.partnerAgreementType.list';

  const postData = {
    // meta: {
  //     startIndex: ((data.pageNumber - 1) * data.itemsPerPage),
  //     numberOfItems: data.itemsPerPage,
  //   },
    // type: data.type,
    // sort: data.sort,
  };

  return axios.post(url, postData);
};

export const requestPartnerAgreementType = (context: any, data: any) => {
  const url = '/-/trade/api/settings.partnerAgreementType.info';

  return axios.post(url, { id: data.id });
};

export const processPartnerAgreementType = (context: any, data: any) => {
  const url = '/-/trade/api/settings.partnerAgreementType.save';

  return axios.post(url, data);
};

// RECURRING COMMISSION PLANS
export const requestRecurringCommissionPlans = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlan.list';

  const postData = {
    meta: {
      startIndex: (data.pageNumber - 1) * data.itemsPerPage,
      numberOfItems: data.itemsPerPage,
    },
    type: data.type,
    sort: data.sort,
  };

  return axios.post(url, postData);
};

export const requestRecurringCommissionPlan = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlan.info';

  return axios.post(url, { id: data.id });
};

export const requestRecurringCommissionPlanGates = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanGate.list';

  return axios.post(url, { planId: data.planId, sort: data.sort });
};

export const requestRecurringCommissionPlanGate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanGate.info';

  return axios.post(url, data);
};

export const processRecurringCommissionPlanGate = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanGate.save';

  return axios.post(url, data);
};

export const requestRecurringCommissionPlanGatePercentages = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanGatePercentage.list';

  return axios.post(url, data);
};

export const requestRecurringCommissionPlanGatePercentage = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanGatePercentage.info';

  return axios.post(url, data);
};

export const processRecurringCommissionPlanGatePercentage = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanGatePercentage.save';

  return axios.post(url, data);
};

export const requestRecurringCommissionPlanPeriod = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanPeriod.info';

  return axios.post(url, data);
};

export const requestRecurringCommissionPlanPeriods = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanPeriod.list';

  return axios.post(url, data);
};

export const processRecurringCommissionPlanPeriod = (context: any, data: any) => {
  const url = '/-/trade/api/settings.recurringCommissionPlanPeriod.save';

  return axios.post(url, data);
};

// GROUPS
export const requestGroups = (context: any, data: any) => {
  const url = '/-/trade/api/settings.groups.list';

  return axios.post(url, {
    meta: {
      startIndex: (data.pageNumber - 1) * data.itemsPerPage,
      numberOfItems: data.itemsPerPage,
    },
    type: data.type,
    sort: data.sort,
  });
};

// SIDEMENU
export const setStandingDataSideMenu = (
  context: any,
  categorySideMenu: any,
) => {
  const sideMenu = {
    content: {
      title: categorySideMenu.title,
      type: 'themed',
      sections: {
        filters: categorySideMenu.filters,
        standingDataCategories: {
          title: 'Stamgegevens',
          items: {
            products: {
              title: 'Producten',
              icon: addItemIcon,
              name: 'standingData.products',
            },
            odidoProducts: {
              title: 'Odido Producten',
              icon: addItemIcon,
              name: 'standingData.odidoProducts',
            },
            kpnProducts: {
              title: 'KPN Producten',
              icon: addItemIcon,
              name: 'standingData.kpnProducts',
            },
            provisioningServices: {
              title: 'Services',
              icon: addItemIcon,
              name: 'standingData.provisioningServices',
            },
            groups: {
              title: 'Groepen',
              icon: addItemIcon,
              name: 'standingData.groups',
            },
            pricePlans: {
              title: 'Prijsplannen',
              icon: invoiceIcon,
              name: 'standingData.pricePlans',
            },
            recurringCommissionPlans: {
              title: 'Periodieke commissieplannen',
              icon: commissionIcon,
              name: 'standingData.recurringCommissionPlans',
            },
            partnerTypes: {
              title: 'Partner types',
              icon: partnerIcon,
              name: 'standingData.partnerTypes',
            },
            productTerms: {
              title: 'Product termijnen',
              icon: calendarTimeIcon,
              name: 'standingData.productTerms',
            },
            logs: {
              title: 'Logboeken',
              icon: warningIcon,
              name: 'standingData.logs',
            },
            queueMonitor: {
              title: 'Queue Monitor',
              icon: warningIcon,
              name: 'standingData.queueMonitor',
            },
          },
        },
      },
    },
  };
  return context.dispatch('updateSideMenu', sideMenu);
};
